<template>
  <div>
    <div v-if='isProcessible'>
      <center>
        <div class="left" v-show="selectedFlow.length > 0">
          <a href="#" @click.prevent="back"><i class="fas fa-arrow-left"></i> {{$t("sendBill.paymentMethods")}}</a>
        </div>
        <br>
        <h3 class="bold-font mt-5">{{$t("sendBill.payment")}}: {{amount}}</h3>

        <div v-show="!cardToken">
          <div class='large-font mt-5'>
            {{$t("sendBill.to")}}: {{merchantName}}
          </div>

          <div class="grey-text" v-if="invoice">Invoice: {{invoice}}</div>
        </div>
      </center>

      <div v-show="showable('cc')">
        <cc-generic-pay
          v-bind="$props"
          :show-one-payment-option-form="showOnePaymentOptionForm()"
          :can-apple-google-pay="availableForMerchantPaymentMethods.includes('apple_google_pay')">
        </cc-generic-pay>
      </div>

      <div v-show="showable('klarna')">
        <klarna-pay v-bind="$props"></klarna-pay>
      </div>

      <div v-show="showable('check')">
        <check-pay v-bind="$props"></check-pay>
      </div>

      <div v-show="showable('ach')">
        <ach-pay 
          :show-one-payment-option-form="showOnePaymentOptionForm()"
          v-bind="$props">
        </ach-pay>
      </div>

      <div v-if="showable('paypal') && paypalMerchantId">
        <paypal-pay v-bind="$props"></paypal-pay>
      </div>

      <div v-if="showable('zelle')">
        <zelle-pay 
          :show-one-payment-option-form="showOnePaymentOptionForm()"
          v-bind="$props">
        </zelle-pay>
      </div>

      <div v-show="showablePaymentMethods.length == 0" class="center red-text">
        {{$t("sendBill.noPaymentMethod")}}
      </div>
    </div>
    <div v-else>
      <h3 class='center red-text'>{{$t("sendBill.couldNotProcess")}}</h3>
    </div>
    <div class="switch center mt-25">
      {{$t("sendBill.changeLanguage")}}<br>
      <label>
        Español
        <input type="checkbox" @change="changeLocale" v-model="english">
        <span class="lever"></span>
        English
      </label>
    </div>
  </div>
</template>
<script>
  import ccGenericPay from './cc_generic_pay'
  import klarnaPay from './klarna_pay'
  import checkPay from './check_pay'
  import achPay from './ach_pay'
  import paypalPay from './paypal_pay'
  import zellePay from './zelle_pay'
  import { useCardsBillStore } from "./cc/store"
  import { useBaseStore } from "./base_store"
  import { toRefs } from '@vue/composition-api'

  export default {
    setup() {
      const cardsBillStore = useCardsBillStore();
      const baseStore = useBaseStore();

      return { ...toRefs(cardsBillStore), ...toRefs(baseStore) }
    },
    components: {checkPay, ccGenericPay, klarnaPay, paypalPay, achPay, zellePay},
    props: {
      stripePublishableKey: String,
      merchantStripeId: String,
      linkOrderId: String,
      allowedByMerchantPayments: Array,
      availableForMerchantPaymentMethods: Array,
      amount: String,
      amountNumberParam: Number,
      merchantName: String,
      invoice: String,
      merchantQidParam: String,
      state: String,
      showTips: Boolean,
      genericFlow: Boolean,
      cardGateway: String,
      adyenClientKey: String,
      policyUrl: String,
      merchantVotesUrl: String,
      allowSignAutosubmitSetting: Boolean,
      showVote: Boolean,
      showReview: Boolean,
      showFeedbackHub: Boolean,
      useNpsVote: Boolean,
      paypalClientId: String,
      paypalMerchantId: String,
      bnCode: String,
      performGverify: Boolean,
      zelleId: String,
      zelleDisplayName: String
    },
    created() {
      // Set Store values
      this.allowSignAutosubmit = this.allowSignAutosubmitSetting
      this.merchantQid = this.merchantQidParam
      this.amountNumber = this.amountNumberParam
      this.httpService = this.$http
    },
    data() {
      return {
        requiredSignup: false,
        english: true
      }
    },
    methods: {
      showOnePaymentOptionForm() {
        return this.allowedByMerchantPayments.length == 1
      },
      showable(type) {
        if (this.selectedFlow.length > 0) {
          return this.selectedFlow.includes(type)
        } else {
          return this.showablePaymentMethods.includes(type)
        }
      },
      changeLocale(event) {
        if(event.srcElement.checked) {
          this.$i18n.locale = "en"
        } else {
          this.$i18n.locale = "es"
        }
      },
      back() {
        window.location.reload()
      }
    },
    computed: {
      isProcessible() {
        if (this.state === "new") { return true } else { return false }
      },
      showablePaymentMethods() {
        return this.availableForMerchantPaymentMethods.filter(method =>
          this.allowedByMerchantPayments.includes(method)
        );
      }
    }
  }
</script>
<style>
</style>
